import { Link } from "react-router-dom";

export const Logo = ({ className = "", light = false, testId = "nav-logo" }) => (
  <Link to="/" className={`group inline-flex items-center gap-2.5 ${className}`} data-testid={testId} aria-label="TeaDM home">
    <img src="/img/logo.webp" alt="TeaDM logo — boba cup wearing headphones" width="44" height="44" className="h-11 w-11 rounded-full transition-transform duration-500 group-hover:rotate-[-14deg]" />
    <span className={`font-display text-2xl font-extrabold tracking-tight ${light ? "text-[#fff5e8]" : "text-[#1a0a10]"}`}>
      TeaDM<sup className="ml-0.5 text-[10px]">®</sup>
    </span>
  </Link>
);
